import { sortByOrderInPlace } from "@/common/utils.sort";
import { removeElementFromArray } from "@/common/utils.array";

import eventAction from "@/store/eventAction";
import cache from "@/store/cache";
//import utilsOrder from "@/common/utils.order";

function defaultState() {
  return {
    loaded: false
  };
}
// state
const state = defaultState();

// getters
const getters = {};

// actions
const actions = {
  clear({ state }) {
    Object.assign(state, defaultState());
  },
  socket_cards({ commit, state }, data) {
    //console.log("socket_cards", data);
    if (data.cards) {
      commit(
        "ADD_RANGE",
        data.cards.map(card => {
          return {
            board: cache.boards.byId(card.board_id),
            list: cache.lists.byId(card.list_id),
            card: card
          };
        })
      );
    }

    if (data.alarms) {
      commit(
        "alarms/ADD_RANGE",
        data.alarms.map(alarm => {
          return {
            card: cache.cards.byId(alarm.card_id),
            alarm: alarm
          };
        }),
        { root: true }
      );
    }

    state.loaded = true;
  },
  new({ dispatch }, { list, title }) {
    dispatch(
      "events/emit",
      {
        list: list,
        action: eventAction.card.new,
        data: title
      },
      { root: true }
    );
  },

  editTitle({ dispatch }, { card, title }) {
    //card.title = title;
    dispatch(
      "events/emit",
      {
        action: eventAction.card.title.edit,
        card: card,
        data: title
      },
      { root: true }
    );
  },

  editDescription({ dispatch }, { card, description }) {
    //card.description = description;
    dispatch(
      "events/emit",
      {
        action: eventAction.card.description.edit,
        card: card,
        data: description
      },
      { root: true }
    );
  },

  archive({ dispatch }, card) {
    dispatch(
      "events/emit",
      {
        action: eventAction.card.archive,
        board: cache.boards.byId(card.board_id),
        list: cache.lists.byId(card.list_id),
        card: card
      },
      { root: true }
    );
  },

  dearchive({ dispatch }, card) {
    dispatch(
      "events/emit",
      {
        action: eventAction.card.dearchive,
        board: cache.boards.byId(card.board_id),
        list: cache.lists.byId(card.list_id),
        card: card
      },
      { root: true }
    );
  },

  move({ dispatch }, { list, card, order }) {
    list = list ? list : cache.lists.byId(card.list_id);

    dispatch(
      "events/emit",
      {
        action: eventAction.card.move,
        list: list,
        card: card,
        data: order
      },
      { root: true }
    );
  },

  handleEvent({ rootState, commit }, event) {
    const requirements = eventAction.requireFor(rootState, event);
    if (!requirements) return;

    const board = requirements.board;
    const list = requirements.list;
    const card = requirements.card;

    switch (event.action) {
      case eventAction.card.new: {
        const newCard = {
          id: event.card_id,
          board_id: board.id,
          in_board_id: event.param2,
          list_id: list.id,
          title: event.data,
          user_id: event.user_id,
          order: event.data2,
          date: event.date
        };

        commit("ADD", {
          board: board,
          list: list,
          card: newCard
        });
        break;
      }
      case eventAction.card.title.edit: {
        card.title = event.data;
        break;
      }
      case eventAction.card.description.edit: {
        card.description = event.data;
        break;
      }
      case eventAction.card.description.append: {
        card.description += event.data;
        break;
      }
      case eventAction.card.archive: {
        commit("ARCHIVE", {
          board: board,
          list: list,
          card: card,
          status: true
        });
        break;
      }
      case eventAction.card.dearchive: {
        commit("ARCHIVE", {
          board: board,
          list: list,
          card: card,
          status: false
        });
        break;
      }
      case eventAction.card.move: {
        if (event.data) {
          card.order = event.data;
        } else {
          console.error("moveCard must has data!");
          break;
        }
        if (card.list_id != event.list_id) {
          const previous_list_id = card.list_id;
          card.list_id = event.list_id;

          removeElementFromArray(cache.lists.byId(previous_list_id).cards, card);
          if (!list.cards.some(c => c.id == card.id)) {
            //it can be already in this list
            list.cards.push(card);
          }
        }
        sortByOrderInPlace(list.cards);

        if (card.alarms && card.alarms.length) {
          //дублируем логику с backend, что уведомления на карточке выключаются, если перетаскиваем в другой список
          card.alarms.forEach(a => {
            if (card.list_id != a.list_id) {
              a.enabled = false;
            }
          });
        }
        break;
      }
    }
  }
};

function add(state, board, list, card) {
  if (!card) return;

  if (!card.id) {
    console.error("Cant add card without id", card);
    return;
  }

  if (!list) {
    console.error("list is not existing for card", card);
    return;
  }

  if (!cache.cards.tryAdd(card)) {
    return;
  }

  if (card.archived) {
    if (!board) {
      console.error("board is not existing for card", card);
      return;
    }
    if (!board.archive.cards.find(l => l.id == card.id)) {
      board.archive.cards.push(card);
      sortByOrderInPlace(board.archive.cards);
    }
  } else {
    if (!list.cards.find(l => l.id == card.id)) {
      list.cards.push(card);
      sortByOrderInPlace(list.cards);
    }
  }
}
// mutations
const mutations = {
  ADD_RANGE(state, items) {
    items.forEach(i => {
      add(state, i.board, i.list, i.card);
    });
  },
  ADD(state, { board, list, card }) {
    add(state, board, list, card);
  },
  ARCHIVE(state, { board, list, card, status }) {
    if (!card) return;

    if (!card.id) {
      console.error("Cant archive card without id", card);
      return;
    }

    if (!list) {
      console.error("list is not existing for card", card);
      return;
    }

    if (!board) {
      console.error("board is not existing for list", list);
      return;
    }

    card.archived = status;
    if (status) {
      removeElementFromArray(list.cards, card);
      if (!board.archive.cards.some(c => c.id == card.id)) {
        //it can be already in this list
        board.archive.cards.push(card);
      }
    } else {
      removeElementFromArray(board.archive.cards, card);
      if (!list.cards.some(c => c.id == card.id)) {
        //it can be already in this list
        list.cards.push(card);
      }
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
